/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Location = {
  /**
   * Unique location identifier
   */
  id: number;
  /**
   * Location name
   */
  name: string;
  /**
   * Location type
   */
  type: Location.type;
  /**
   * Location address
   */
  address: string;
  /**
   * Location status
   */
  status: Location.status;
  /**
   * Creation timestamp
   */
  createdAt: string;
};
export namespace Location {
  /**
   * Location type
   */
  export enum type {
    WAREHOUSE = 'WAREHOUSE',
    BRANCH = 'BRANCH',
  }
  /**
   * Location status
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
  }
}
